module.exports = __webpack_public_path__ + "img/icon-doc.2e183818.svg";